export default __webpack_public_path__ + "7fd982d00fd608cc2bf6e501ac9e0816.pdf";